<template>
  <nuxt-link
    :to="link"
    data-spotlight
    class="group relative isolate flex h-full flex-col overflow-hidden rounded-3xl bg-white ring-1 ring-gray-200 active:ring-brand-200 shadow-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
  >
    <shape-spotlight />

    <atomic-card-media
      v-if="image"
      :image="image"
      :image-alt="imageAlt ?? title"
      sizes="xs:480px sm:640px lg:520px"
      class="aspect-[4/3]"
    />

    <div class="flex flex-1 flex-col gap-y-3 p-6 sm:p-8">
      <atomic-icon-square
        v-if="iconName"
        :icon-name="iconName"
      />

      <h3 class="text-lg font-display font-semibold tracking-tight text-gray-900">
        {{ title }}
      </h3>

      <p class="text-sm/6 text-gray-600">
        {{ description }}
      </p>

      <span class="mt-auto inline-flex items-center gap-x-1.5 pt-2 text-sm font-semibold text-brand-600 transition group-hover:text-brand-700">
        {{ ctaLabel }}

        <icon
          name="ph:arrow-right"
          aria-hidden="true"
          class="size-4 transition group-hover:translate-x-0.5"
        />
      </span>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { LinkCardProps } from 'types/section'

const { ctaLabel = 'En savoir plus' } = defineProps<LinkCardProps>()
</script>
